<template>
  <v-card class="pa-5" flat>
    <v-row class="pa-5 pb-0 d-flex justify-space-between align-center">
      <span class="text-h6 font-weight-medium">My Details</span>
      <div v-if="ProfileDetails">
        <v-btn
          v-if="!editMode"
          @click="toggleEditMode"
          fab
          small
          depressed
          color="#00B3FF"
          class="mr-2 white--text"
          sole
        >
          <v-icon>mode_edit</v-icon>
        </v-btn>
        <v-btn
          v-if="editMode"
          @click="saveChanges"
          fab
          small
          depressed
          color="blue"
          class="mr-2 white--text"
          sole
        >
          <v-icon>mdi-check</v-icon>
        </v-btn>
        <v-btn
          v-if="editMode"
          @click="cancelChanges"
          fab
          small
          depressed
          color="gray"
          class="mr-2 white--text"
          sole
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-row>
    <v-row v-if="ProfileDetails">
      <v-col>
        <v-list>
          <ProfileDetailItem
            v-if="ProfileDetails.first_name"
            :icon="'double_arrow'"
            :label="'First Name'"
            :value="ProfileDetails.first_name"
            :edit-mode="editMode"
            @input="updateProfileDetail('first_name', $event)"
          ></ProfileDetailItem>
          <ProfileDetailItem
            v-if="ProfileDetails.last_name"
            :icon="'double_arrow'"
            :label="'Last Name'"
            :value="ProfileDetails.last_name"
            :edit-mode="editMode"
            @input="updateProfileDetail('last_name', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.email"
            :icon="'double_arrow'"
            :label="'Email'"
            :value="ProfileDetails.email"
            @input="updateProfileDetail('email', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.mobile"
            :icon="'double_arrow'"
            :label="'Mobile'"
            :value="ProfileDetails.mobile"
            :edit-mode="editMode"
            @input="updateProfileDetail('mobile', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.employer && ProfileDetails.employer.address01"
            :icon="'double_arrow'"
            :label="'Address 1'"
            :value="ProfileDetails.employer.address01"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.address01', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.employer && ProfileDetails.employer.address02"
            :icon="'double_arrow'"
            :label="'Address 2'"
            :value="ProfileDetails.employer.address02"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.address02', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.employer && ProfileDetails.employer.city"
            :icon="'double_arrow'"
            :label="'City'"
            :value="ProfileDetails.employer.city"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.city', $event)"
          ></ProfileDetailItem>
          <v-divider class="border-opacity-25"></v-divider>
          <ProfileDetailItem
            v-if="ProfileDetails.employer && ProfileDetails.employer.state"
            :icon="'double_arrow'"
            :label="'State'"
            :value="ProfileDetails.employer.state"
            :edit-mode="editMode"
            @input="updateProfileDetail('employer.state', $event)"
          ></ProfileDetailItem>
        </v-list>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ProfileDetailItem from "@/components/profile/ProfileDetailItem.vue";

export default {
  components: {
    ProfileDetailItem,
  },
  props: {
    ProfileDetails: Object,
  },
  data() {
    return {
      editMode: false,
      tempProfileDetails: null,
    };
  },
  methods: {
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (this.editMode) {
        this.tempProfileDetails = { ...this.ProfileDetails };
      }
    },
    saveChanges() {
      const formData = new FormData();
      formData.append("first_name", this.ProfileDetails["first_name"]);
      formData.append("last_name", this.ProfileDetails["last_name"]);
      formData.append("email", this.ProfileDetails["email"]);
      formData.append("mobile", this.ProfileDetails["mobile"] || "");

      const employer = this.ProfileDetails.employer || {};

      formData.append(
        "address01",
        this.ProfileDetails["employer.address01"] || employer.address01 || ""
      );
      formData.append(
        "address02",
        this.ProfileDetails["employer.address02"] || employer.address02 || ""
      );
      formData.append(
        "city",
        this.ProfileDetails["employer.city"] || employer.city || ""
      );
      formData.append(
        "state",
        this.ProfileDetails["employer.state"] || employer.state || ""
      );

      this.$emit("update-employer", formData);
      this.editMode = false;
    },
    cancelChanges() {
      this.ProfileDetails = { ...this.tempProfileDetails };
      this.editMode = false;
    },
    updateProfileDetail(key, value) {
      this.$set(this.ProfileDetails, key, value);
    },
  },
};
</script>

<style scoped>
.icon-box {
  border-radius: 30%;
}

.detail-label {
  font-weight: 500;
  color: black;
  padding-top: 20px;
}

.detail-value {
  color: #555;
  font-weight: 400;
}
</style>
